<template>
    <iframe
        class="bunny-video"
        :src="`https://iframe.mediadelivery.net/embed/${activeLibraryId}/${bunnyId}?autoplay=${autoplay}&loop=${loop}&muted=${muted}&preload=${preload}`"
        :loading="loading"
        allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
        allowfullscreen="true"
    />
</template>

<script setup>
const props = defineProps({
    bunnyId: {
        type: String,
        required: true
    },
    autoplay: {
        type: Boolean,
        default: false
    },
    loop: {
        type: Boolean,
        default: false
    },
    muted: {
        type: Boolean,
        default: false
    },
    preload: {
        type: Boolean,
        default: true
    },
    loading: {
        type: String,
        default: 'lazy',
        validator: value => ['lazy', 'eager'].includes(value)
    },
    libraryId: {
        type: String,
        default: null
    }
});

const { libraryId } = toRefs(props);

const config = useRuntimeConfig();
const activeLibraryId = computed(() => {
    if (libraryId.value) {
        return libraryId.value;
    }

    return config.public.mainBunnyLibraryId ?? null;
});
</script>

<style lang="less">
.bunny-video {
    display: block;
    border: 0;
    aspect-ratio: 16 / 9;
    width: 100%;
}
</style>
